'use client';

import { clientSelectionLabels } from '../../utils/clientSelectionLabels';

interface ClientsSelectAllActionProps {
  isAllSelected: boolean;
  total: number;
  onSelectAll: () => void;
  onClearSelection: () => void;
}

const linkClassName =
  'flex items-center border-none bg-transparent py-1 px-0 text-button-semibold text-blue-300 cursor-pointer hover:underline max-md:shrink-0 max-md:whitespace-nowrap max-md:text-sm max-md:font-medium';

export const ClientsSelectAllAction = ({
  isAllSelected,
  total,
  onSelectAll,
  onClearSelection,
}: ClientsSelectAllActionProps) => {
  if (isAllSelected) {
    return (
      <button type="button" onClick={onClearSelection} className={linkClassName}>
        Clear Selection
      </button>
    );
  }

  if (total <= 0) {
    return null;
  }

  return (
    <button type="button" onClick={onSelectAll} className={linkClassName}>
      {clientSelectionLabels.selectAll(total)}
    </button>
  );
};
